import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconHourglassFull$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHourglassFull extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3b06dd3fa984528c27b20a6dcf168b465945aa27', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd7c97f8b86b50cc197c1c1fcc2c8ba3d6719eee1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4b5f3ae16f8f697f191f31c61560e0050a370e42', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 5.44V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v1.94c0 3 1.78 4.66 3.67 6C7.77 12.77 6 14.26 6 16.94v1.56a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1.56c0-2.68-1.77-4.17-3.67-5.49C14.22 10.1 16 8.41 16 5.44M7.5 4.5h7v.94a4.8 4.8 0 0 1-.35 1.81H7.86a4.6 4.6 0 0 1-.36-1.81zm7 12.44v.55h-7v-.55c0-2.13 1.6-3.29 3.5-4.58 1.9 1.29 3.5 2.45 3.5 4.58", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-hourglass-full", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-hourglass-full"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-hourglass-full":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHourglassFull$1);
            }
            break;
    } });
}

const CosmosIconHourglassFull = CosmosIconHourglassFull$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHourglassFull, defineCustomElement };
